<script setup lang="ts">
import { SuggestionProps } from "./Suggestion.props"
import {
  VIEW_ITEM_LIST_IDS,
  VIEW_ITEM_LIST_NAMES
} from "~/utils/analytics/viewItemList"

defineProps<SuggestionProps>()

const route = useRoute()

const isEncyclopediaPage = computed(() =>
  String(route.path).toLowerCase().includes("enciclopedia")
)

const listName = computed(() =>
  isEncyclopediaPage.value
    ? VIEW_ITEM_LIST_NAMES.ENCYCLOPEDIA
    : VIEW_ITEM_LIST_NAMES.ARTICLES
)
</script>

<template>
  <div
    v-if="products"
    class="
      product-suggestion-wrapper
      bg-grey-main
      flex flex-col
      gap-4
      p-4
      pb-6
      md:rounded
      md:px-4
    "
  >
    <p class="pig-bold text-green-main">
      {{ $t("productBlocks.suggestion.product") }}
    </p>

    <GAList
      :id="VIEW_ITEM_LIST_IDS.RECOMMENDED_PRODUCTS"
      :name="listName"
      entity="pageList"
    >
      <GAItem
        :id="`recommended-products-${$route.params.article}-${$route.params.category}`"
        :item="products"
      >
        <GAViewItemList
          :name="listName"
          :id="VIEW_ITEM_LIST_IDS.RECOMMENDED_PRODUCTS"
        />
      </GAItem>

      <ProductTileOverallResults
        v-if="products"
        v-for="(product, index) in products"
        :key="index"
        v-bind="product"
        class="w-auto"
        :itemId="VIEW_ITEM_LIST_IDS.RECOMMENDED_PRODUCTS"
        :itemList="listName"
      />
    </GAList>
  </div>
</template>
